{
  "title": "Оголошення",
  "description": "Загальношкільні та класні новини.",
  "loading": "Завантаження…",
  "empty": {
    "title": "Оголошень ще немає",
    "staffText": "Опублікуйте оголошення для класу — воно потрапить у сповіщення кожного учасника.",
    "readerText": "Тут з’являються оголошення вашої школи та ваших класів.",
    "filterTitle": "За цими фільтрами оголошень немає",
    "filterText": "Для цієї аудиторії, класу чи пошукового запиту нічого немає. Скиньте фільтри, щоб побачити всю стрічку."
  },
  "pinned": "Закріплено",
  "pin": "Закріпити",
  "unpin": "Відкріпити",
  "audience": {
    "school": "Уся школа",
    "class": "Один клас",
    "label": "Аудиторія"
  },
  "filters": {
    "audience": "Аудиторія",
    "all": "Усі",
    "class": "Клас",
    "allClasses": "Усі класи",
    "search": "Пошук оголошень",
    "searchPlaceholder": "Шукати в заголовку чи тексті…",
    "clear": "Скинути фільтри"
  },
  "card": {
    "by": "від {{name}}",
    "edited": "змінено"
  },
  "compose": {
    "button": "Нове оголошення",
    "title": "Нове оголошення",
    "editTitle": "Редагувати оголошення",
    "titleLabel": "Заголовок",
    "titlePlaceholder": "Про що йдеться?",
    "bodyLabel": "Текст",
    "audienceLabel": "Хто це побачить",
    "classLabel": "Клас",
    "selectClass": "Оберіть клас",
    "pinLabel": "Закріпити вгорі стрічки",
    "submit": "Опублікувати",
    "save": "Зберегти зміни",
    "saving": "Зберігаємо…",
    "cancel": "Скасувати",
    "teacherNote": "Учителі публікують оголошення для своїх класів; загальношкільні публікує адміністратор.",
    "titleRequired": "Додайте заголовок оголошення.",
    "classRequired": "Оберіть клас, для якого це оголошення."
  },
  "actions": {
    "edit": "Редагувати",
    "delete": "Видалити",
    "menu": "Дії з оголошенням",
    "deleteConfirmTitle": "Видалити це оголошення?",
    "deleteConfirmBody": "Воно зникне зі стрічки в усіх учасників. Повернути його не вдасться."
  },
  "toasts": {
    "created": "Оголошення опубліковано.",
    "updated": "Оголошення оновлено.",
    "deleted": "Оголошення видалено.",
    "pinned": "Закріплено вгорі.",
    "unpinned": "Відкріплено."
  },
  "latestCard": {
    "title": "Останнє оголошення",
    "empty": "Оголошень поки немає.",
    "seeAll": "Усі оголошення"
  }
}
